/**
 * Side-effect module: registers the analytics-event detail panel with the shell's record-panel
 * registry (DR-11). Registration is LAZY (registerLazyRecordPanel): the
 * mapping is installed synchronously at boot so deep links resolve, but the
 * panel component (and its dependency graph) stays out of the entry chunk
 * and loads on first open. Idempotent.
 */

import { registerLazyRecordPanel } from '../../shell/record-panel-registry'

// Analytics events get their OWN panel type. Registering this under 'activity'
// (as it originally was) clobbered the CRM activity detail panel whenever an
// events route loaded, so timeline activity rows opened the wrong panel and
// event lookups 500'd on activity ids.
registerLazyRecordPanel('analyticsEvent', () =>
  import('./event-side-panel').then((m) => ({ default: m.EventSidePanel })),
)
